import { type FC } from "react";

import { type PropsWithClassName } from "@/components/podkit/lib/cn";

export const WindsurfLogo: FC<PropsWithClassName> = ({ className }) => {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="24" height="24" fill="#0D0D0D" />
            <path
                d="M23.7787 5.00377H23.55C22.3463 5.00189 21.3695 5.98219 21.3695 7.19248V12.0874C21.3695 13.0649 20.5661 13.8566 19.6099 13.8566C19.0417 13.8566 18.4746 13.5691 18.138 13.0865L13.1667 5.94637C12.7542 5.35347 12.083 5 11.3565 5C10.223 5 9.20306 5.96899 9.20306 7.16514V12.0883C9.20306 13.0658 8.40623 13.8576 7.44347 13.8576C6.87347 13.8576 6.30727 13.5701 5.9707 13.0875L0.407797 5.09709C0.282176 4.91611 0 5.00566 0 5.22622V9.49524C0 9.71109 0.0656226 9.92033 0.18843 10.0976L5.6632 17.9598C5.98664 18.4245 6.46383 18.7695 7.01409 18.8948C8.39123 19.2096 9.65869 18.1436 9.65869 16.7853V11.8649C9.65869 10.8875 10.4461 10.0957 11.4183 10.0957H11.4211C12.007 10.0957 12.5564 10.3832 12.8929 10.8658L17.8652 18.005C18.2787 18.5988 18.9152 18.9514 19.6746 18.9514C20.8333 18.9514 21.826 17.9815 21.826 16.7862V11.864C21.826 10.8865 22.6135 10.0947 23.5856 10.0947H23.7797C23.9016 10.0947 24 9.99575 24 9.87324V5.22528C24 5.10274 23.9016 5.00377 23.7797 5.00377H23.7787Z"
                fill="white"
            />
        </svg>
    );
};
